module.exports = __webpack_public_path__ + "static/media/city2.7df31f90.jpg";